/**
 * The faceted mark from the design, drawn at the same 32-unit box with the
 * same three paths.
 *
 * The fills are the accent tokens rather than the design's literal `#25C16F`
 * and `#E5F145`, so the mark follows whichever accent the reader has chosen in
 * the customiser instead of staying green while the rest of the app turns.
 *
 * Decorative: the wordmark beside it carries the name, so announcing the
 * drawing as well would say it twice.
 */
export function BrandMark({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 32 32" fill="none" aria-hidden="true" focusable="false" className={className}>
      <path d="M4 16L15 5V27L4 16Z" className="fill-accent-2 opacity-90" />
      <path d="M15 5L28 16L15 27V5Z" className="fill-accent opacity-95" />
      <path d="M15 9L23 16L15 23V9Z" fill="#FFFFFF" fillOpacity="0.25" />
    </svg>
  );
}
